<template>
  <div id="main" class="d-f-m">
    <div class="main_visual">
      <main-visual />
    </div>
    <template v-if="casinoList && casinoList.length!==0">
      <div class="main_img">
        <div class="m_title_area">
          <span><strong>LIVE CASINO</strong></span>
          <div class="d-f mr-30"></div>
        </div>
      </div>
      <div class="m_casino_area">
        <ul>
          <template v-if="mainCasinoList && mainCasinoList.length !== 0">
            <template v-for="item in mainCasinoList" :key="item.procId">
              <li>
                <div class="m_casino" @click="$router.push('/casino')">
                  <p class="logo">
                    <img :src="item.imgSrc" alt="" />
                  </p>
                  <p class="img"></p>
                  <p class="c_mask"></p>
                  <strong>{{ $t(`front.gameCode.casino.${item.procId}`) }}</strong>
                </div>
              </li>
            </template>
          </template>
        </ul>
      </div>
    </template>
    <div class="main_img">
      <template v-if="slotList && slotList.length!==0">
        <div class="m_title_area">
          <span><strong>SLOT GAMES</strong></span>
          <div class="d-f mr-30"></div>
        </div>

        <div class="m_slot_area">
          <ul>
            <template v-if="mainSlotList && mainSlotList.length !== 0">
              <template v-for="item in mainSlotList" :key="item.procId">
                <li>
                  <div class="m_slot" @click="$router.push('/slot')" >
                    <p class="logo">
                      <img :src="getLoadImage(`assets/img/logo/${item.procId}-1`,'png')" alt="" />
                    </p>
                  </div>
                </li>
              </template>
            </template>
          </ul>
        </div>
      </template>
      <template v-if="sportsList && sportsList.length!==0">
        <div class="m_title_area">
          <span><strong>SPORTS BETTING</strong></span>
          <div class="d-f mr-30"></div>
        </div>
        <div class="main_sports">
          <div class="left_cont">
            <div class="incont">
              <div class="txt">SPORTS BET</div>
            </div>
          </div>
          <div class="right_cont">
            <div class="m_sports_area">
              <ul>
                <template v-if="mainSportsList && mainSportsList.length !== 0">
                  <template v-for="item, index in mainSportsList" :key="item.procId">
                    <li @click="$router.push('/sports')">
                      <img class="model" :src="getLoadImage(`assets/img/winner_pc/main/sports_model_${index+1}`,'png')" alt="" />
                      <div class="m_sports">
                        <p class="img"></p>
                        <p class="c_mask"></p>
                        <strong>{{ $t(`front.gameCode.sports.${item.procId}`) }}</strong>
                      </div>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </template>
      <template v-if="minigameList && minigameList.length !== 0">
        <div class="m_title_area">
          <span><strong>MINI GAMES</strong></span>
          <div class="d-f mr-30"></div>
        </div>
        <div class="main_games">
          <div class="right_cont">
            <div class="m_sports_area">
              <ul>
                <template v-if="mainMimiList && mainMimiList.length !== 0">
                  <template v-for="item, index in mainMimiList" :key="item.procId">
                    <li>
                      <img class="model" :src="getLoadImage(`assets/img/winner_pc/main/mini_model_${index+1}`, 'png')" alt="" />
                      <div class="m_miniGames" @click="$router.push('/mini')">
                        <p class="img"></p>
                        <p class="c_mask"></p>
                        <strong>{{ $t(`front.gameCode.minigame.${item.procId}`) }}</strong>
                      </div>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
          </div>
          <div class="left_cont">
            <div class="incont">
              <div class="txt">
                <img src="@/assets/img/winner_pc/main/text_mini.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="m_notice_area">
        <ul>
          <li>
            <div class="m_notice">
              <div class="tit">{{ $t('front.common.notice') }}</div>
              <div class="list">
                <template v-if="boardList.length !== 0">
                  <Vue3Marquee :vertical="true" :pause-on-hover="true" @on-pause="playState = 'paused'" @on-resume="playState = 'playing'" :pause="boardList.length < 5">
                    <router-link v-for="item in boardList" :key="item.boardidx" :to="{ name: 'noticedetail', params: { boardIdx: item.boardIdx } }">
                      <strong>{{ item.title }}</strong>
                      <span>{{ getDateStr(item.updDate) }}</span>
                    </router-link>
                  </Vue3Marquee>
                </template>
              </div>
            </div>
          </li>
          <li>
            <div class="m_notice">
              <div class="tit">{{ $t(`front.main.livecharge`) }}</div>
              <div class="list">
                <template v-if="cashListIn.length !== 0">
                  <Vue3Marquee :vertical="true" :pause-on-hover="true" @on-pause="playState = 'paused'" @on-resume="playState = 'playing'">
                    <a v-for="item in cashListIn" :key="item.cashIdx">
                      <strong>{{ convertAnonymous(item.memId, 4, '*') }}</strong>
                      <span class="green">{{ thousand(item.cashAmt) }}</span>
                      <span>{{ getDateStr(item.updDate) }}</span>
                    </a>
                  </Vue3Marquee>
                </template>
              </div>
            </div>
          </li>
          <li>
            <div class="m_notice">
              <div class="tit">{{ $t(`front.main.liveExchange`) }}</div>
              <div class="list">
                <template v-if="cashListOut.length !== 0">
                  <Vue3Marquee :vertical="true" :pause-on-hover="true" @on-pause="playState = 'paused'" @on-resume="playState = 'playing'">
                    <a v-for="item in cashListOut" :key="item.cashIdx">
                      <strong>{{ convertAnonymous(item.memId, 4, '*') }}</strong>
                      <span class="green">{{ thousand(item.cashAmt) }}</span>
                      <span>{{ getDateStr(item.updDate) }}</span>
                    </a>
                  </Vue3Marquee>
                </template>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="mainPopWrap">
    <template v-for="(item) in popupList" v-bind:key="item.bannerIdx">
      <div class="mainPop" v-if="item.delYn === 'N' && !item.isClose" :data-idx="item.bannerIdx">
        <div class="closeWrap">
          <a class="close" @click="popupCloseByCookie(item)">{{ $t('front.main.today') }}</a>
          <a class="close" @click="popupClose(item)">{{ $t('front.main.close') }}</a>
        </div>
        <!-- <img :src="item.bannerImg" /> -->
        <editor-viewer ref="editor" :content="item.bannerImg" />
      </div>
    </template>
  </div>
</template>

<script>
import { getPopupCookie, setPopupCookie, tokenCheck } from '@/libs/auth-helper'
import MainVisual from '@/components/common/MainVisual.vue'
import { getMain, getMainCashStatus, getMainNotice } from '@/api/main'
import { mapState } from 'vuex'

import store from '@/store'
import { thousand, getDateStr, convertAnonymous, imageLoader } from '../libs/utils'

import { reqMainInfo } from '@/api/common'
import { Vue3Marquee } from 'vue3-marquee'
import { PAGE_TYPE } from '@/libs/constants'
import EditorViewer from '@/components/EditorViewer'

export default {
  name: 'Index.vue',
  components: {
    MainVisual,
    Vue3Marquee,
    EditorViewer
  },
  created() {
    this.loadMain()
    this.popupMerge()
    this.getMainInfo()
  },
  data() {
    return {
      currentTab: 'tab-1',
      popupList: {},
      cashInList: [],
      cashOutList: [],
      noticeList: [],
      listMaxCount: 5,
      boardList: [],
      cashListIn: [],
      cashListOut: [],
      playState: 'playing'
    }
  },
  watch: {
    popup() {
      this.popupMerge()
    },
    popupLogin() {
      this.popupMerge()
    },
    async userData() {
      await store.dispatch('storePopup')
      if (this.userData) {
        await store.dispatch('storePopupLogin')
      }
      this.popupMerge()
    }
  },
  computed: {
    ...mapState([
      'userData',
      'commonCode',
      'commonCodeByOrder',
      'popup',
      'popupLogin',
      'banner',
      'gameCount'
    ]),
    mainCasinoList() {
      return this.casinoList.slice(0, 8)
    },
    mainSlotList() {
      return this.slotList.slice(0, 4)
    },
    mainSportsList() {
      return this.sportsList.slice(0, 4)
    },
    mainMimiList() {
      return this.minigameList.slice(0, 4)
    }
  },
  methods: {
    async getMainInfo() {
      const request = {
        siteId: process.env.VUE_APP_SITE_ID,
        userPageType: PAGE_TYPE
      }
      try {
        const response = await reqMainInfo(request)
        const { data } = response.data
        const { boardList, cashListIn, cashListOut } = data
        if (boardList) {
          this.boardList = boardList
        }
        if (cashListIn) {
          this.cashListIn = cashListIn
        }
        if (cashListOut) {
          this.cashListOut = cashListOut
        }
      } catch (e) {
        console.log(e)
      }
    },
    convertAnonymous,
    thousand,
    getDateStr,
    loadCashStatus() {
      getMainCashStatus({}).then(res => {
        const result = res.data
        if (result.resultCode === '200') {
          console.log(result.data)
          this.cashInList = result.data.cashInList
          this.cashOutList = result.data.cashOutList
        }
      })
    },
    getLoadImage(path, mime) {
      try {
        const image = imageLoader(path, mime)
        if (image) {
          return image
        } else {
          return ''
        }
      } catch (e) {
        return ''
      }
    },
    loadNotice() {
      getMainNotice({}).then(res => {
        const result = res.data
        if (result.resultCode === '200') {
          this.noticeList = result.data.noticelist
        }
      })
    },
    getBackgroundImage(item) {
      try {
        const image = require('../assets/img/game_main_pc_' + item.code + '_off.png')
        const imageOff = require('../assets/img/game_main_pc_' + item.code + '_off.png')
        if (image && imageOff) {
          if (item.isHover) {
            return { backgroundImage: 'url(' + image + ')' }
          } else {
            return { backgroundImage: 'url(' + imageOff + ')' }
          }
        } else {
          return { backgroundImage: 'url()' }
        }
      } catch (e) {
        return { backgroundImage: 'url()' }
      }
    },
    getBackgroundLogoImage(item) {
      try {
        const image = require('../assets/img/glogo' + item.code + '.png')
        return { backgroundImage: 'url(' + image + ')' }
      } catch (e) {
        return { backgroundImage: 'url()' }
      }
    },
    popupMerge() {
      const popupLogin = this.userData ? this.popupLogin : []
      const pList = this.popup.concat(popupLogin)

      this.popupList = {}

      pList.forEach(item => {
        if (!item.isClose) {
          const key = item.bannerIdx
          const siteId = process.env.VUE_APP_SITE_ID || 'moka'
          const name = siteId + '_popup_' + item.bannerIdx
          const cookie = getPopupCookie(name)
          if (cookie) {
            item.isClose = true
          } else {
            item.isClose = false
          }
          if (!this.popupList[key]) {
            this.popupList[key] = item
          }
        }
      })
    },
    popupClose(item) {
      item.isClose = true
    },
    popupCloseByCookie(item) {
      item.isClose = true
      setPopupCookie(item)
    },
    slotOpen(event, groupCode, codeName, code) {
      this.emitter.emit(event, { groupCode, codeName, code })
      this.emitter.emit('Loading', false)
    },
    loadMain() {
      if (this.userData) {
        getMain({}).then(res => {
          // console.log(res)
        })
      }
    }
  },
  async beforeRouteEnter(to, from, next) {
    await tokenCheck()
    // if (result) {
    next()
    // }
  }
}
</script>

<!-- <style src="@/styles/winner_pc/common.css"></style> -->
<style src="@/styles/winner_pc/main.css"></style><!-- <style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/main.css"></style> -->
<style scoped>
.vue3-marquee {
  width: 100%;
  height: 100%;
}

.marquee {
  width: 100%;
}

.mainPopWrap {
  display: flex;
  align-items: center;
  gap: 50px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1005;
}

.mainPop {
  position: relative;
  min-width: 320px;
  background: #fff;
  border: 1px solid #777;
  z-index: 100;
}

.mainPop .closeWrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
  position: absolute;
  bottom: 0;
  padding: 15px;
  background: rgba(0, 0, 0, .7);
  color: #fff;
  font-size: 12px;
  z-index: 2;
}

.mainPop a.close {
  color: #fff;
}

.mainPop > img {
  width: 430px;
  height: 640px;
  vertical-align: bottom;
  object-fit: cover;
  object-position: center;
}
</style>
